// import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import * as React from "react";
import { get } from "lodash";
// import * as MaterialIcon from "@material-ui/icons";
import MaterialIcon from '@material-ui/core/Icon';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { ComponentTypes } from "../../types";
import reducers from "../Button/reducers";
// import { EditorMode } from "@/Apps/Pages/Editor/types";

import { IconTypes, IconProps, IconSource, PluginProps } from "./types";
import { V1ObjectWrapper, convertProperties } from "../V1ObjectWrapper";
import { ComponentTypes, EditorMode } from "@/Apps/Pages/Editor/types";
import { ComponentRenderHooks } from "@/plugins/types";
import { parseLiquidObject } from "@/Apps/Pages/Page/LiquidRenderer";

const convertToSnakeCase = str => {

  switch (str) {
    case "3d_rotation":
      return "ThreeDRotation";
    case "4k":
      return "FourK";
    case "360":
      return "ThreeSixty";
  }

  return str.replace(/\.?([A-Z])/g, function (x, y) { return "_" + y.toLowerCase() }).replace(/^_/, "");
}

export const Icon: React.FC<IconProps> = (props) => {
  const {
    style = {},
    className = "",
    properties = {},
    type = IconTypes.Block,
    source = IconSource.MATERIAL,
    actions = [],
    updateComponentSettings = () => null,
    getComponentSettings = () => null,
    mode = EditorMode.LIVE,
    onClick = () => null,
  } = props;
  // const IconComponent = MaterialIcon[type];

  // if you follow this path, make sure to add the following to the index.html
  // <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
  const IconComponent = ({ style, onClick }) => {
    if (type === "Twitter") return <TwitterIcon className={className} style={parseLiquidObject(style)} onClick={onClick} />;
    if (type === "Instagram") return <InstagramIcon className={className} style={parseLiquidObject(style)} onClick={onClick} />;
    if (type === "YouTube") return <YouTubeIcon className={className} style={parseLiquidObject(style)} onClick={onClick} />;
    if (type === "WhatsApp") return <WhatsAppIcon className={className} style={parseLiquidObject(style)} onClick={onClick} />;
    return <MaterialIcon className={className} style={parseLiquidObject(style)} onClick={onClick}>{convertToSnakeCase(type)}</MaterialIcon>
  }

  const handleIconClick = () => {
    if (actions) {
      const doTheseActions = actions.filter((itm) => itm.behavior === "click");
      doTheseActions.forEach((action) => {
        reducers([], {
          ...action,
          settings: props,
          updateComponentSettings,
          getComponentSettings,
        })
      }
      );
    }
  };

  return (
    <span
      data-testid="WC-ICON-LIVE"
      onClick={handleIconClick}
      style={parseLiquidObject({
        padding: 0,
        margin: 0,
        border: "none",
        boxShadow: "none",
        background: "transparent",
        cursor: mode === EditorMode.LIVE ? "pointer" : "grab",
        // display: "flex",
        // alignItems: "center",
        textAlign: "center",
        ...style,
        ...properties,
      })}
    >
      {source === IconSource.MATERIAL && (
        <IconComponent
          className={className}
          style={parseLiquidObject({
            ...style,
            ...properties,
            padding: 0,
            border: "none",
            marginTop: 0,
            marginBottom: 0,
            backgroundColor: "transparent",
          })}
          onClick={onClick}
        />
      )}
      {source === IconSource.FONTAWESOME && (
        <FontAwesomeIcon
          className={className}
          style={parseLiquidObject({
            ...style,
            ...properties,
            padding: 0,
            border: "none",
            marginTop: 0,
            marginBottom: 0,
            backgroundColor: "transparent",
          })}
          icon={type}
          onClick={onClick}
        />
      )}
      {/* {source === IconSource.SVG && (
        <svg
          fill="currentColor"
          width="100%"
          height="100%"
          viewBox="-2 -2 24 24"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMinYMin"
          className={className}
          style={parseLiquidObject({
            ...style,
            ...properties,
          })}
          onClick={onClick}
        >
          <path d="M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z" />
          <path d="M11.586 11H6a1 1 0 1 1 0-2h5.586L9.05 6.464a1 1 0 0 1 1.414-1.414l4.243 4.243a.997.997 0 0 1 0 1.414l-4.243 4.243a1 1 0 1 1-1.414-1.414L11.586 11z" />
        </svg>
      )} */}
    </span>
  );
};

const IconPluginComponent: React.FC<PluginProps> = ({
  settings,
  updateComponentSettings = () => null,
  getComponentSettings = () => null,
  mode = EditorMode.LIVE,
  className = ""
}) => {
  
  const properties = convertProperties(settings.properties);

  return (
    <V1ObjectWrapper settings={settings}>
      <Icon
        className={className}
        {...settings}
        updateComponentSettings={updateComponentSettings}
        getComponentSettings={getComponentSettings}
        mode={mode}
        type={get(settings, "iconType", false)}
        properties={properties}
      />
    </V1ObjectWrapper>
  );
};

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === ComponentTypes.ICON
  ) {
    return [IconPluginComponent];
  }
};

export { IconTypes, IconSource };

export default Icon;
